export default __webpack_public_path__ + "static/media/search.0c78abd0.svg";